import type { FC } from 'react';
import React from 'react';
import { List, Collapse, Grid } from '@mui/material';

import type { ScenarioDto } from '@/api-gen/api.schemas';
import type { SceneGroupListItemProps } from 'app/components/NavigationDrawer/ScenarioSection/NavigationDrawerScenarioList/SceneGroupListItem.tsx';
import SceneGroupListItem from 'app/components/NavigationDrawer/ScenarioSection/NavigationDrawerScenarioList/SceneGroupListItem.tsx';

import SceneGroupContainerListItem from './SceneGroupContainerListItem.tsx';
import type { SceneGroupWithScenes, NavigationDrawerClasses } from './types.ts';

interface SceneGroupContainerProps extends SceneGroupListItemProps {
  classes: NavigationDrawerClasses;
  sceneId: number | null;
  sceneGroup: SceneGroupWithScenes;
  openSceneGroups: number[];
  handleSelectScenario: () => void;
  renderContextMenu: (sceneGroupId: number) => JSX.Element;
  handleClickOnGroupSubmenu: (sceneGroupId: number) => void;
  handleRightClick: (event: React.MouseEvent<HTMLElement>, scene: ScenarioDto) => void;
}

const SceneGroupContainer: FC<SceneGroupContainerProps> = React.memo(
  ({
    classes,
    sceneId,
    sceneGroup,
    handleRightClick,
    renderContextMenu,
    openSceneGroups,
    handleSelectScenario,
    handleClickOnGroupSubmenu,
    isSubGroup
  }): JSX.Element => {
    // Determine if this group is expanded
    const isOpen = openSceneGroups.includes(sceneGroup.id);

    return (
      <Grid key={'sceneGroupList' + sceneGroup.id}>
        <SceneGroupListItem
          classes={classes}
          sceneGroup={sceneGroup}
          isSubGroup={isSubGroup}
          openSceneGroups={openSceneGroups}
          handleClickOnGroupSubmenu={handleClickOnGroupSubmenu}
        />
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" data-cy="listForScnario" disablePadding>
            {sceneGroup.subGroups?.map((subGroup) => (
              <SceneGroupContainer
                key={subGroup.id}
                classes={classes}
                sceneId={sceneId}
                openSceneGroups={openSceneGroups}
                handleSelectScenario={handleSelectScenario}
                handleClickOnGroupSubmenu={handleClickOnGroupSubmenu}
                handleRightClick={handleRightClick}
                renderContextMenu={renderContextMenu}
                sceneGroup={subGroup}
                isSubGroup
              />
            ))}
            {sceneGroup.scenes.map((scene) => (
              <SceneGroupContainerListItem
                scene={scene}
                key={scene.id}
                classes={classes}
                handleRightClick={handleRightClick}
                handleSelectScenario={handleSelectScenario}
                sceneId={sceneId}
                isSubGroupItem={true}
                disableActions={sceneGroup.disableActions}
              />
            ))}
            {renderContextMenu(sceneGroup.id)}
          </List>
        </Collapse>
      </Grid>
    );
  }
);

SceneGroupContainer.displayName = 'SceneGroupContainer';

export default SceneGroupContainer;
